const BlockTitle = ({ text }) => {
  return (
    <div className="bg-primary py-4 pl-4 font-pop text-xl font-medium uppercase text-white">
      {text}
    </div>
  );
};

export default BlockTitle;
